import { render, staticRenderFns } from "./HalfImageHalfGridTwo.vue?vue&type=template&id=16a563ff"
import script from "./HalfImageHalfGridTwo.vue?vue&type=script&lang=js"
export * from "./HalfImageHalfGridTwo.vue?vue&type=script&lang=js"
import style0 from "./HalfImageHalfGridTwo.vue?vue&type=style&index=0&id=16a563ff&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports